var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "toutiao-page" },
    [
      _c(
        "Swipe",
        {
          staticClass: "my-swipe",
          attrs: { autoplay: 3000, "indicator-color": "white" }
        },
        [
          _c("SwipeItem", [
            _c("img", {
              attrs: {
                src: require("@/assets/toutiao-download/Frame2362.png"),
                alt: ""
              }
            })
          ]),
          _c("SwipeItem", [
            _c("img", {
              attrs: {
                src: require("@/assets/toutiao-download/Frame2363.png"),
                alt: ""
              }
            })
          ]),
          _c("SwipeItem", [
            _c("img", {
              attrs: {
                src: require("@/assets/toutiao-download/Frame2364.png"),
                alt: ""
              }
            })
          ])
        ],
        1
      ),
      _c("div", { staticClass: "footer" }, [
        _vm._m(0),
        _c("div", { staticClass: "btn", on: { click: _vm.download } }),
        _vm._m(1)
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "qr-code" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/toutiao-download/qr_code.png"),
          alt: ""
        }
      }),
      _c("p", [
        _vm._v("现在就打开微信扫描二维码 "),
        _c("br"),
        _vm._v("下载 "),
        _c("span", [_vm._v("法临APP ")]),
        _vm._v("吧～ ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/toutiao-download/Frame2241@2x.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }